export default {
  carouselAriaLabel: {
    id: 'product_page_carousel_aria_label',
    defaultMessage: '{productName} stock photo image gallery',
  },
  mainImageButtonAriaLabel: {
    id: 'product_page_carousel_main_image_button_aria_label',
    defaultMessage: 'Stock photo of {productName}',
  },
  thumbnailButtonAriaLabel: {
    id: 'product_page_carousel_thumbnail_button_aria_label',
    defaultMessage: 'Stock photo of {productName}, image {current} of {total}',
  },
  videoButtonAriaLabel: {
    id: 'product_page_carousel_video_button_aria_label',
    defaultMessage: 'Play video for {productName}',
  },
  videoThumbnailButtonAriaLabel: {
    id: 'product_page_carousel_video_thumbnail_button_aria_label',
    defaultMessage: 'Video of {productName}',
  },
  reviewButtonAriaLabel: {
    id: 'product_page_carousel_review_button_aria_label',
    defaultMessage: 'Customer review photo for {productName}',
  },
  reviewThumbnailButtonAriaLabel: {
    id: 'product_page_carousel_review_thumbnail_button_aria_label',
    defaultMessage: 'Customer review photo of {productName}',
  },
} as const
